<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.dealerNo" placeholder="经销商编号"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filters.dealerName" placeholder="经销商名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filters.hospitalCode" placeholder="授权医院ZCN"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filters.hospitalName" placeholder="授权医院名称"></el-input>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
      <!-- <el-upload v-if="PLGX_IF" style="display:inline-block;margin-right:20px;padding-bottom:12px"
            class="upload-demo" ref="upload" action="/images/Upload/file" :headers="token" :show-file-list="false"
            :on-success='handleSuccess' :before-upload='handlebefore' :on-error='handonerror'>
            <el-button type="primary">批量更新</el-button>
          </el-upload> -->
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          v-if="!isMobile"
          border
          :max-height="tableHeight"
          :data="users"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
        >
          <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->
          <el-table-column type="index" width="80">
            <template slot="header" slot-scope="{}">
              <span style="padding: 8px 0">
                序号
                <span class="caret-wrapper" style="width: 0px"></span>
              </span>
              <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
            </template>
          </el-table-column>
          <el-table-column prop="dealerNo" label="经销商编号" min-width="110"></el-table-column>
          <el-table-column prop="dealerName" label="经销商名称" min-width="280"></el-table-column>
          <el-table-column prop="product" label="授权产品" min-width="90"></el-table-column>
          <el-table-column prop="hospitalCode" label="授权医院ZCN" min-width="130"></el-table-column>
          <el-table-column prop="hospitalName" label="授权医院名称" min-width="200"></el-table-column>
          <el-table-column prop="isMonth" label="授权是否当月算起" min-width="130"></el-table-column>
          <el-table-column prop="licensedStartDate" label="授权开始日期" min-width="110"></el-table-column>
          <el-table-column prop="licensedEndDate" label="授权结束日期" min-width="110"></el-table-column>
          <el-table-column prop="modifyTime" label="修改时间" min-width="160"></el-table-column>
          <!-- <el-table-column  label="操作" width="260">

        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">操作 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
        </template>
        <template scope="scope">
          <el-link type="primary" @click="handledetails(scope.row)">
            <i class="el-icon-tickets"></i>详情 
          </el-link>
          <el-link type="primary"  v-if="EDIT_IF  && (scope.row.status ==0 ||scope.row.status ==-1)" @click="handleEdit(scope.row)">&nbsp;|&nbsp;<i class="el-icon-edit"></i>编辑</el-link>
        </template>
      </el-table-column> -->
        </el-table>
      </div>
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :current-page="page"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  HcoGetVersionList,
  HcoQueryPage,
  DealerQueryPage,
  QueryDealerHospitalRelationPage,
  HcoHcoInfoExportExcel,
  store_data_Reback_Store,
  HcoHcoExportExcel,
  regionGetRegionTree,
  EmployeeRegionGetEmployeeRegionTrees,
  HcoImprotUpdateList,
  HcoGetHcoCatGroup,
  HcoGetHcoRefGroup,
  DealerMasterDataDealerHospitalRelationExportExcel,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
// import { number } from 'echarts/lib/export';

export default {
  components: { Toolbar },
  data() {
    return {
      EDIT_BCXX_IF: false,
      name_list: [],
      zcn_list: [],
      GLY_IF: false,
      isMobile: false,
      HBSC_IF: false,
      VersionList_list: [],
      mbdc_version: '',
      mbdcdialogVisible: false,
      dc_form: {},
      CatGroup_list: [],
      RefGroup_list: [],
      Employee_list: [],
      DC_MODE: false,
      tableHeight: 0,
      currentPage2: 5,
      editFormRules1: {
        Code: [{ required: true, message: '请选择', trigger: 'blur' }],
        RID: [{ required: true, message: '请选择', trigger: 'blur' }],
        PREID: [{ required: true, message: '请选择', trigger: 'blur' }],
        Name: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      form1: {
        isimediate: false,
        filepath: '',
        date: '',
      },
      LJGX: true,
      dialogVisible1: false,
      token: {},
      PLGX_IF: false,
      HCO_LIST_IF: false,
      SalesOperation_if: false,
      edit_if_2: false,
      EDIT_IF: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      region_list: [],
      city_list: [],
      sels: [], //列表选中列
    }
  },
  methods: {
    plmb_dc() {
      location.href =
        'https://share-ui.oss-cn-shanghai.aliyuncs.com/202308_JJSVMDM/data_template/%E5%8C%BB%E9%99%A2%E6%89%B9%E9%87%8F%E6%9B%B4%E6%96%B0_%E6%A8%A1%E6%9D%BF.xlsx'
    },
    storage_data() {
      if (this.filters.name) {
        if (this.name_list.length == 15) {
          this.name_list.splice(14, 1)
        }
        for (var i in this.name_list) {
          console.log(this.name_list[i].value)
          console.log(this.filters.name)
          if (this.name_list[i].value == this.filters.name) {
            this.name_list.splice(i, 1)
            console.log(this.name_list)
          }
        }
        this.name_list.unshift({
          value: this.filters.name,
        })
      }
      if (this.filters.bwacctnumber) {
        if (this.zcn_list.length == 15) {
          this.zcn_list.splice(14, 1)
        }
        for (var i in this.zcn_list) {
          if (this.zcn_list[i].value == this.filters.bwacctnumber) {
            this.zcn_list.splice(i, 1)
          }
        }
        this.zcn_list.unshift({
          value: this.filters.bwacctnumber,
        })
      }

      //  var name_list = JSON.
      // JSON.parse
      // JSON.stringify
      localStorage.setItem('name_list', JSON.stringify(this.name_list))
      localStorage.setItem('zcn_list', JSON.stringify(this.zcn_list))
      console.log(localStorage.getItem('name_list'))
    },
    querySearch(queryString, cb) {
      var restaurants = this.name_list
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    querySearch2(queryString, cb) {
      var restaurants = this.zcn_list
      console.log(restaurants)
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    isimediate_change(e) {
      if (e == true) {
        this.form1.date = ''
      }
    },
    async plgx_submit() {
      // if(this.form1.isimediate){
      //     this.form1.date =''
      // }
      if (!this.form1.isimediate && !this.form1.date) {
        this.$message({
          message: '请选择生效时间',
          type: 'error',
        })
        return
      }
      if (!this.form1.filepath) {
        this.$message({
          message: '请上传批量更新文件',
          type: 'error',
        })
        return
      }
      const { data } = await HcoImprotUpdateList(this.form1)
      if (data.success) {
        this.$message({
          message: data.msg,
          type: 'success',
        })
        this.getModules_search()
        this.dialogVisible1 = false
      } else {
        this.$message({
          message: data.msg,
          type: 'error',
        })
      }
    },
    btn_up_2(e) {
      window.open('https://preview.51i.cc/onlinePreview?url=' + encodeURIComponent('https://' + location.host + '/' + e))
    },
    async EmployeeRegionGetEmployeeRegionTrees_fn() {
      const { data } = await EmployeeRegionGetEmployeeRegionTrees()
      this.Employee_list = data.response
    },
    Level_3and4Change(e) {
      if (!e) {
        return
      }
      this.dc_form.sales_region_id = e[e.length - 1]
      console.log(this.dc_form.sales_region_id)
    },
    async regionGetRegionTree_fn() {
      const { data } = await regionGetRegionTree()
      this.region_list = data.response
    },
    city_change(e) {
      this.city_list.find((item) => {
        if (item.name === e) {
          this.dc_form.cityid = item.id
          // this.city_list = item.children
        }
      })
    },
    province_change(e) {
      this.region_list.find((item) => {
        if (item.name === this.dc_form.province_name) {
          this.dc_form.ProvinceID = item.id
          this.city_list = item.children
          console.log(this.city_list)
          console.log(this.dc_form.ProvinceID)
        }
      })
    },
    all_upload() {
      this.dialogVisible1 = true
    },
    handleClose(done) {
      done()
    },
    handlebefore(file) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      const isLt1M = file.size / 1024 / 1024 < 20

      // if (!isJPG) {
      //   this.$message.error('上传文件只能是 JPG 格式!')
      // }
      if (!isLt1M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }
      loading.close()
      return isLt1M
    },
    handonerror() {
      console.log('超时失败')

      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      this.$message({
        message: '您的上传已超时，请再次尝试',
        type: 'error',
      })
      loading.close()
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      if (file.success) {
        this.form1.filepath = file.response
        // this.UPLOAD_IF = true
        loading.close()
        this.$message({
          message: file.msg,
          type: 'success',
        })
        this.$refs.upload.clearFiles()
      } else {
        loading.close()
        this.$message({
          message: file.msg,
          type: 'error',
        })
        this.$refs.upload.clearFiles()
      }
    },
    cp_zk_click() {
      if (this.HCO_LIST_IF) {
        this.HCO_LIST_IF = false
      } else {
        this.HCO_LIST_IF = true
      }
    },
    mbdcdialogVisible_submit() {
      let para = this.filters
      HcoHcoExportExcel({
        version: this.mbdc_version,
      }).then((res) => {
        this.mbdcdialogVisible = false
        window.open('/api' + res.data.response)
        // window.location.href =
      })
    },
    all_ExportAccount() {
      this.mbdcdialogVisible = true
    },
    mode_uplode() {
      let para = this.dc_form
      console.log(para)
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      HcoHcoInfoExportExcel(para).then((res) => {
        if (res.data.status == 200) {
          this.DC_MODE = false
        }
        loading.close()
        window.open('/api' + res.data.response)
      })
    },
    ExportAccount() {
      let para = this.filters
      const loading = this.$loading({
        lock: true,
        text: 'loading......',
      })
      DealerMasterDataDealerHospitalRelationExportExcel(para).then((res) => {
        loading.close()
        window.open('/api' + res.data.response)
      })
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // 导出
    // ExportAccount() {
    //   // let para = this.filters
    //   let para = {};
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   store_data_ExportStore(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? '正常' : '未知'
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == '' ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd')
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.filters.pageSize = val
      this.getModules()
    },
    handleCurrentChange(val) {
      this.page = val
      //   console.log(val)
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.storage_data()
      this.getModules()
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      console.log(para)
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true
      QueryDealerHospitalRelationPage(para).then((res) => {
        this.total = res.data.response.dataCount
        this.users = res.data.response.data
        this.listLoading = false
      })
    },
    //删除
    handleDel(ids) {
      console.log(ids)
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true
          //NProgress.start();
          let para = { id: ids }
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false
              return
            }
            this.listLoading = false
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: '删除成功',
                type: 'success',
              })
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }

            this.getModules()
          })
        })
        .catch(() => {})
    },
    handleWithdraw(id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success) {
          this.$message({
            message: '撤回成功',
            type: 'success',
          })
          this.getModules()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    handledetails: function (e) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          id: e.ID,
          approval_data_id: e.approval_data_id,
          type: 'CK',
          back_url: '/HCO/HCO_list',
          filters_list: this.filters,
        },
      })
    },
    //编辑
    handleEdit: function (e, type) {
      // console.log(id)
      // return
      var types = 'EDIT'
      if (type == 'HBSC') {
        types = 'CK'
      }
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          id: e.ID,
          type: types,
          status: type,
          back_url: '/HCO/HCO_list',
          filters_list: this.filters,
        },
      })
    },
    handleAdd() {
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          type: 'ADD',
          back_url: '/HCO/HCO_list',
        },
      })
    },

    handledetails_SalesOperation: function (ids, progress, outletnumber__c) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    //localStorage 存储数组对象的方法
    saveObjArr(name, data) {
      localStorage.setItem(name, JSON.stringify(data))
    },

    //localStorage 获取数组对象的方法
    getObjArr(name) {
      return JSON.parse(window.localStorage.getItem(name))
    },
    details_tag(name) {
      var router_list = this.getObjArr('router')
      for (let i in router_list) {
        for (let s in router_list[i].children) {
          //  console.log(999)
          if (router_list[i].children[s].id == '175') {
            //  console.log(999)
            router_list[i].children[s].name = name
            router_list[i].children[s].meta.title = name
            console.log(router_list[i].children[s].name)
            this.saveObjArr('router', router_list)
            console.log(this.getObjArr('router'))
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list)
    },
    async HcoGetHcoCatGroup_fn() {
      const { data } = await HcoGetHcoCatGroup()
      this.CatGroup_list = data.response
    },
    async HcoGetHcoRefGroup_fn() {
      const { data } = await HcoGetHcoRefGroup()
      this.RefGroup_list = data.response
    },
    async HcoGetVersionList_fn() {
      const { data } = await HcoGetVersionList()
      this.VersionList_list = data.response
    },
  },
  mounted() {
    if (localStorage.getItem('name_list')) {
      this.name_list = JSON.parse(localStorage.getItem('name_list'))
    }
    if (localStorage.getItem('zcn_list')) {
      this.zcn_list = JSON.parse(localStorage.getItem('zcn_list'))
    }
    // this.name_list = JSON.parse(localStorage.getItem('name_list'))
    // this.zcn_list =JSON.parse(localStorage.getItem('zcn_list'))
    this.isMobile = window.innerWidth <= 767
    console.log(this.isMobile)
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - 250
      })
    })
    console.log(this.tableHeight)
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    var user_details = JSON.parse(window.localStorage.getItem('user'))
    var user_RoleNames = user_details.RoleNames
    this.GLY_IF =
      user_RoleNames.filter(function (e) {
        return e == '管理员'
      }).length != 0
    console.log(this.$route.query)
    if (this.$route.query.filters_list !== '[object Object]' && this.$route.query !== undefined) {
      console.log(this.$route.query)
      if ('filters_list' in this.$route.query && this.$route.query.filters_list) {
        console.log(this.$route.query)
        this.filters = this.$route.query.filters_list
      }
    }
    // if(this.$route.query.filters_list !== "[object Object]" && this.$route.query.filters_list){
    //     console.log(111)
    //     if('filters_list' in this.$route.query){
    //         console.log(111)
    //         this.filters = this.$route.query.filters_list
    //     }
    // }
    this.getModules()
    this.HcoGetVersionList_fn()
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
    if (this.buttonList) {
      if (
        this.buttonList.filter(function (e) {
          return e.name == '编辑'
        }).length != 0
      ) {
        this.EDIT_IF = true
      }
      if (
        this.buttonList.filter(function (e) {
          return e.name == '编辑补充信息'
        }).length != 0
      ) {
        this.EDIT_BCXX_IF = true
      }
      // this.buttonList = this.buttonList.filter(function (e) {
      //   return e.name != "编辑";
      // })
      if (
        this.buttonList.filter(function (e) {
          return e.name == '合并/删除'
        }).length != 0
      ) {
        this.HBSC_IF = true
      }
      this.buttonList = this.buttonList.filter(function (e) {
        return e.name != '合并/删除' && e.name != '编辑' && e.name != '编辑补充信息'
      })
    }
    //  if (this.buttonList) {
    //     if (
    //       this.buttonList.filter(function (e) {
    //         return e.name == "批量更新";
    //       }).length != 0
    //     ) {
    //       this.PLGX_IF = true;
    //     }
    //     this.buttonList = this.buttonList.filter(function (e) {
    //       return e.name != "批量更新";
    //     })

    //   };
  },
}
</script>

<style scoped>
.el-select,
.el-date-editor,
.el-cascader {
  width: 100% !important;
}
</style>
